import { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { ListKeys, featuresList } from '../../../api/list'
import { FormBuilderContainer } from '../../../components/formBuilder/formBuilder.container'
import { FormItemTypes, IFormBuilder, ValueTypes } from '../../../components/formBuilder/formBuilder.entity'
import { createFeatureAccess, getFeatureAccessbyId, updateFeatureAccess } from './apiCall'
import { FeatureAccessNames, FeaturesAccessKeys, getAttributesByFeatureAccess } from './entity'

export default function FeaturesAccessEdit() {
  let { id } = useParams();

  const formData: IFormBuilder['formData'] = [
    // {
    //   type: FormItemTypes.TextInput,
    //   name: 'Name',
    //   label: 'Name',
    //   value: null,
    //   required: true,
    //   maxLength: 100,
    //   valueTypes: ValueTypes.onlyAlphabets
    // },
    {
      type: FormItemTypes.SearchSelect,
      name: 'FeatureId',
      label: 'Feature',
      value: null,
      displayExpr: "Name",
      valueExpr: "id",
      getListData: featuresList,
      apiKey: ListKeys.features,
      required: true,
      disabled: !!id
    },
    {
      type: FormItemTypes.SearchSelect,
      name: 'Name',
      label: 'Name',
      required: true,
      options: FeatureAccessNames,
      displayExpr: 'id',
    },
    {
      type: FormItemTypes.TextInput,
      name: 'DisplayName',
      label: 'Display Name',
      value: null,
      required: true,
      maxLength: 100,
      valueTypes: ValueTypes.onlyAlphabets
    },
    // {
    //   type: FormItemTypes.TextInput,
    //   name: 'Attribute',
    //   label: 'Attribute',
    //   value: null,
    //   required: true,
    //   maxLength: 100,
    //   valueTypes: ValueTypes.bothStringNumber
    // },
    {
      type: FormItemTypes.SearchSelect,
      name: 'Attribute',
      label: 'Attribute',
      required: true,
    },
  ]

  const setFieldProps = useCallback<NonNullable<IFormBuilder['setFieldProps']>>((val, state, field) => {
    switch (field.name) {
      case 'Attribute':
        if (!state?.Name) {
          return {
            disabled: true
          }
        }
        return {
          options: getAttributesByFeatureAccess(state?.Name),
          displayExpr: 'id'
        }
    }
  }, [])

  return (
    <FormBuilderContainer
      formData={formData}

      getFormAPI={getFeatureAccessbyId}
      getRequest={{ id: id }}
      getKey={FeaturesAccessKeys.get}

      createFormAPI={createFeatureAccess}
      createKey={FeaturesAccessKeys.create}

      updateFormAPI={updateFeatureAccess}
      updateKey={FeaturesAccessKeys.update}

      headerLabel={id ? 'Add Feature Access' : 'Feature Access'}

      setFieldProps={setFieldProps}
      parentPath={'/featureAccess'}
    />
  )
}